import type { ReactNode } from 'react';
import type { UsageSheetSuccess } from '@shared/types/forge-usage-sheet';

/**
 * « Réussite » (22/10): from how many good items a run has done its job. The
 * user edits the threshold and the criteria in place; the threshold never goes
 * above what is wanted.
 */
export const SuccessLine = ({ success, text, onChange }: {
  success: UsageSheetSuccess;
  text: (value: string, label: string, onSave: (value: string) => void) => ReactNode;
  onChange: (success: UsageSheetSuccess) => void;
}) => {
  const setEnough = (value: string) => {
    const enough = Number.parseInt(value.replace(/\D/g, ''), 10);
    if (!Number.isFinite(enough) || enough < 1) return;
    onChange({ ...success, enough: success.wanted.value !== null ? Math.min(enough, success.wanted.value) : enough, status: 'confirmed' });
  };
  const wanted = success.wanted.value !== null
    ? `${success.wanted.value} voulus`
    : success.wanted.input ? `autant que « ${success.wanted.input} »` : '';
  return <p className="mt-1 text-domino-inkSoft">
    <span className="font-medium">Réussi dès </span>
    {text(String(success.enough), 'Seuil de réussite', setEnough)}
    {' : '}
    {text(success.criteria, 'Critères de réussite', (criteria) => onChange({ ...success, criteria, status: 'confirmed' }))}
    {wanted ? ` (${wanted})` : ''}
  </p>;
};
